import { render, staticRenderFns } from "./FwdCku.vue?vue&type=template&id=5b2e3b8b&"
import script from "./FwdCku.vue?vue&type=script&lang=js&"
export * from "./FwdCku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports